<script lang="ts">
    import { onMount } from "svelte";
    import { errorMessage } from "./store";
    import { blur } from "svelte/transition";

    onMount(() => {
        errorMessage.subscribe((value) => {
            if (!value) return;
            setTimeout(() => {
                errorMessage.set("");
            }, 5000);
        });
    });
</script>

<div class="flex flex-col fixed items-center w-full">
    {#if $errorMessage}
        <span
            transition:blur
            class=" flex gap-8 content-center border-2 border-red-300 shadow-md rounded-lg py-2 px-4 bg-red-50"
        >
            <span class="flex flex-col">
                <p class="text-gray-500">{$errorMessage}</p>
            </span>
            <div>
                <button on:click={() => errorMessage.set("")}>×</button>
            </div>
        </span>
    {/if}
</div>
